import classnames from 'classnames/bind';
import { NavLink } from 'react-router-dom';

import styles from './MenuItem.module.css';

const cls = classnames.bind(styles);

export const MenuItem = ({ route, icon: Icon, text, className, ...props }) => (
  <NavLink
    to={route}
    className={cls('nav-link', className)}
    activeClassName={cls('active')}
    {...props}
  >
    <Icon className={cls('icon')} aria-hidden />
    <span className={cls('text')}>{text}</span>
  </NavLink>
);
